import axios from "axios";

const serverUrl = process.env.VUE_APP_URL;

export default {
    methods: {
        getAvailableRawMaterials: async function () {
            const getAvaiableRawMaterialsUrl = `${serverUrl}RawMaterials/GetAvailableRawMaterials`;
            return axios.get(getAvaiableRawMaterialsUrl)
        },
        getAllRawMaterials: async function () {
            const getAvaiableRawMaterialsUrl = `${serverUrl}RawMaterials/GetAllRawMaterials`;
            return axios.get(getAvaiableRawMaterialsUrl)
        },
        getRawMaterialDeliveries: async function (deliveryId) {
            const getRawMaterialDeliveriesUrl = `${serverUrl}Delivery/GetRawMaterialDeliveriesSummary/${deliveryId}`
            return axios.get(getRawMaterialDeliveriesUrl)
        },
        getRawMaterialDetails : async function (rawMaterialId){
            const getRawMaterialDeliveriesUrl = `${serverUrl}RawMaterials/GetRawMaterialDetailInfoById/${rawMaterialId}`
            return axios.get(getRawMaterialDeliveriesUrl)
        },
        getAvailableRawMaterialsById : async function (rawMaterialTypeId){
            const getAvailableRawMaterialsByIdUrl = `${serverUrl}RawMaterials/GetAvailableRawMaterialsByRawMaterialTypeId/${rawMaterialTypeId}`
            return axios.get(getAvailableRawMaterialsByIdUrl)
        }
    },
};
